var hasProp = window.hasProp;
var extend = window.extend;
var bind = window.bind;
var bind = function (fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  },
  extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
AcademiaSharing.Bookmark = function (superClass) {
  extend(Bookmark, superClass);
  function Bookmark() {
    this.sync = bind(this.sync, this);
    return Bookmark.__super__.constructor.apply(this, arguments);
  }
  Bookmark.prototype.modelName = "bookmark";
  Bookmark.prototype.routeKey = "api_v0_bookmark";
  Bookmark.for_target_arx = function (target_arx, attrs) {
    var id, model, ref, type;
    if (attrs == null) {
      attrs = {};
    }
    ref = target_arx.split("/"), type = ref[0], id = ref[1];
    model = new AcademiaSharing.Bookmark({
      content_type: type,
      content_id: parseInt(id)
    });
    model.set(attrs);
    return model;
  };
  Bookmark.prototype.target_arx = function () {
    return this.get('content_type') + "/" + this.get('content_id');
  };
  Bookmark.prototype.url = function (method) {
    if (method === "read" && this.id == null) {
      return $r.find_api_v0_bookmarks_path({
        "subdomain_param": "api",
        "bookmark[content_type]": this.get("content_type"),
        "bookmark[content_id]": this.get("content_id")
      });
    } else {
      return Bookmark.__super__.url.apply(this, arguments);
    }
  };
  Bookmark.prototype.sync = function (method, model, options) {
    var result;
    result = Bookmark.__super__.sync.apply(this, arguments);
    if (result && (method === 'create' || method === 'update')) {
      result.done(function (_this) {
        return function () {
          return _this.trigger('save');
        };
      }(this));
    }
    return result;
  };
  Bookmark.prototype.preview_url = function () {
    return $r.html_api_v0_work_path({
      id: this.get("content_id"),
      subdomain_param: "api"
    });
  };
  Bookmark.prototype.toJSON = function () {
    return _.omit(this.attributes, "preview");
  };
  return Bookmark;
}(Academia.Model);
window.bind = bind;
window.extend = extend;
window.hasProp = hasProp;